import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Auth from "../../../../utils/Auth";
import { withTranslation } from "react-i18next";
import WithRouter from "../../../../components/Common/WithRouter";
import { get, includes, reverse, toLower } from "lodash";
import { request } from "../../../../utils/Request";
import { utcDateToLocalDate, formatDate } from "../../../../utils/Helper";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Divider } from "primereact/divider";
import { Tag } from "primereact/tag";
import OrderDamageCaseActionBadge from "../../../../components/Common/Display/OrderDamageCaseActionBadge";
import OrderDamageCaseLabelBadge from "../../../../components/Common/Display/OrderDamageCaseLabelBadge";
import OrderDamageCaseStatus from "../../../../components/Common/Display/OrderDamageCaseStatus";
import { Chatbox } from "../../../../components/Chat";
import Tooltip from "../../../../components/Common/Display/Tooltip";

const ClosedOrderDamageCaseDetail = (props: any) => {
    const { t, toastify, params } = props;
    const [entity, setEntity] = useState<any>(null);
    const auth = new Auth();
    const [chatboxOpen, setChatboxOpen] = useState<boolean>(false);
    const [selectedDamageCode, setSelectedDamageCode] = useState<any>(null);

    const getDetail = async (id: string) => {
        try {
            const response = await request({
                url: `/suppliers/order/damage/cases/closed/${ id }`
            });

            const { data } = response.data;
            setEntity(data);
        } catch (error) {
            toastify(t("server error"), "error");
        }
    };

    useEffect(() => {
        if ( includes(['detail'], get(params, ['operation'])) ) {
            getDetail(params.operationId);
        }
    }, [params]);

    return (
        <div className={ "p-4 bg-white" }>
            {
                entity &&
              <>
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('case number') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ get(entity, ['case_number']) || '-' }</div>
                      </Col>
                  </Row>

                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('VIN number') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ get(entity, ['order', 'vin_number']) || '-' }</div>
                      </Col>
                  </Row>

                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('brand') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ get(entity, ['order', 'brand', 'title']) || '-' }</div>
                      </Col>
                  </Row>

                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('model') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">
                              { get(entity, ['order', 'model', 'title']) || '-' }
                          </div>
                      </Col>
                  </Row>

                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('insurance company') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ get(entity, ['insurance_company']) || '-' }</div>
                      </Col>
                  </Row>

                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('carrier') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ get(entity, ['supplier_carrier']) || '-' }</div>
                      </Col>
                  </Row>

                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('assignee') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ get(entity, ['assignee']) || '-' }</div>
                      </Col>
                  </Row>

                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('sub contractor') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ get(entity, ['sub_contractor']) || '-' }</div>
                      </Col>
                  </Row>

                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('gate in') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">
                              { get(entity, ['gate_in']) ? utcDateToLocalDate(get(entity, ['gate_in'])) : '-' }
                          </div>
                      </Col>
                  </Row>

                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('damage date') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">
                              { get(entity, ['damage_date']) ? formatDate(get(entity, ['damage_date'])) : '-' }
                          </div>
                      </Col>
                  </Row>

                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('status') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">
                              <OrderDamageCaseStatus status={ get(entity, ['status']) } />
                          </div>
                      </Col>
                  </Row>

                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('notes') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">{ get(entity, ['notes']) || '-' }</div>
                      </Col>
                  </Row>

                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('created at') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">
                              { get(entity, ['created_at']) ? utcDateToLocalDate(get(entity, ['created_at'])) : '-' }
                          </div>
                      </Col>
                  </Row>

                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h6>
                              <span className="text-capitalize">{ t('updated at') }</span>
                          </h6>
                      </Col>
                      <Col md="6" lg="6" sm="12">
                          <div className="text-end">
                              { get(entity, ['updated_at']) ? utcDateToLocalDate(get(entity, ['updated_at'])) : '-' }
                          </div>
                      </Col>
                  </Row>

                  <Divider />
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h5>
                              <span className="text-capitalize">{ t('actions') }</span>
                          </h5>
                      </Col>
                      <Col sm="12">
                          <DataTable
                            value={ (get(entity, ['actions']) || []) }
                            dataKey="type"
                            paginator
                            rows={ 5 }
                            className="datatable-responsive"
                            emptyMessage={ t('no data') }
                          >
                              <Column
                                field="type"
                                header={ t('type') }
                                sortable
                                body={(rowData: any) => (
                                    <OrderDamageCaseActionBadge
                                        type={ get(rowData, ['type']) }
                                    />
                                )}
                              />
                              <Column
                                field="created_at"
                                header={ t('created at') }
                                sortable
                                body={(rowData: any) => get(rowData, ['created_at']) ? utcDateToLocalDate(get(rowData, ['created_at'])) : '-'}
                              />
                          </DataTable>
                      </Col>
                  </Row>

                  <Divider />
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h5>
                              <span className="text-capitalize">{ t('labels') }</span>
                          </h5>
                      </Col>
                      <Col sm="12">
                          <DataTable
                            value={ reverse((get(entity, ['labels']) || [])) }
                            dataKey="id"
                            paginator
                            rows={ 5 }
                            className="datatable-responsive"
                            emptyMessage={ t('no data') }
                          >
                              <Column
                                field="label_added_for"
                                header={ t('label added for') }
                                sortable
                                body={(rowData: any) => (
                                    <OrderDamageCaseLabelBadge
                                        labelFor={ get(rowData, ['label_added_for']) }
                                    />
                                )}
                              />
                              <Column
                                field="reply"
                                header={ t('reply') }
                                sortable
                                body={(rowData: any) => get(rowData, ['reply']) || '-'}
                              />
                              <Column
                                field="comment"
                                header={ t('comment') }
                                sortable
                                body={(rowData: any) => get(rowData, ['comment']) || '-'}
                              />
                              <Column
                                field="label_expired_at"
                                header={ t('label expired at') }
                                sortable
                                body={(rowData: any) => get(rowData, ['label_expired_at']) ? utcDateToLocalDate(get(rowData, ['label_expired_at'])) : '-'}
                              />
                              <Column
                                field="created_at"
                                header={ t('created at') }
                                sortable
                                body={(rowData: any) => get(rowData, ['created_at']) ? utcDateToLocalDate(get(rowData, ['created_at'])) : '-'}
                              />
                          </DataTable>
                      </Col>
                  </Row>

                  <Divider />
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h5>
                              <span className="text-capitalize">{ t('damage codes') }</span>
                          </h5>
                      </Col>
                      <Col sm="12">
                          <DataTable
                            value={ get(entity, ['damage_codes']) || [] }
                            dataKey="id"
                            paginator
                            rows={ 5 }
                            className="datatable-responsive"
                            emptyMessage={ t('no data') }
                          >
                              <Column field="code" header={ t('code') } sortable />
                              <Column field="description" header={ t('description') } sortable />
                              <Column field="damage_type" header={ t('damage type') } sortable />
                              <Column field="carrier_status" header={ t('responsibility status') } sortable />
                              <Column field="liability_name" header={ t('liability') } sortable />
                              <Column field="responsibility_name" header={ t('responsibility') } sortable />
                              <Column
                                header={ t('actions') }
                                body={(rowData: any) => {
                                    const emilFreyId = get(rowData, ['emil_frey_id']);
                                    const wasRejected = get(rowData, ['was_rejected']);
                                    if (!(emilFreyId && wasRejected)) return '-';
                                    return (
                                        <Tooltip tooltip={ t('open chat') }>
                                            <a
                                                className="cursor-pointer"
                                                onClick={ () => {
                                                    setSelectedDamageCode(rowData);
                                                    setChatboxOpen(true);
                                                } }
                                                style={{ color: '#007bff' }}
                                            >
                                                <i className="fas fa-comment" />
                                            </a>
                                        </Tooltip>
                                    );
                                }}
                              />
                          </DataTable>
                      </Col>
                  </Row>

                  <Divider />
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h5>
                              <span className="text-capitalize">{ t('calculations') }</span>
                          </h5>
                      </Col>
                      <Col sm="12">
                          <DataTable
                            value={ get(entity, ['calculations']) || [] }
                            dataKey="id"
                            paginator
                            rows={ 5 }
                            className="datatable-responsive"
                            emptyMessage={ t('no data') }
                          >
                              <Column
                                field="title"
                                header={ t('title') }
                                sortable
                                body={(rowData: any) => {
                                    const title = get(rowData, ['title']) || '-';
                                    const url = get(rowData, ['download_url']);
                                    if (!url) return title;
                                    return (
                                        <div className="d-flex align-items-center gap-2">
                                            <div className="flex-grow-1">{ title }</div>
                                            <Tooltip tooltip={ t('download') }>
                                                <a href={ url } target="_blank" rel="noreferrer">
                                                    <i className="fas fa-download" />
                                                </a>
                                            </Tooltip>
                                        </div>
                                    );
                                }}
                              />
                              <Column
                                header={ t('status') }
                                sortable
                                body={(rowData: any) => {
                                    const status = get(rowData, ['status']) || '-';
                                    const severity =
                                        status === 'accepted' ? 'success' :
                                        status === 'rejected' ? 'danger' :
                                        status === 'pending' ? 'warning' :
                                        'secondary';

                                    return <Tag value={ status === '-' ? '-' : t(status) } severity={ severity as any } />;
                                }}
                              />
                              <Column
                                header={ t('created at') }
                                sortable
                                body={(rowData: any) => get(rowData, ['created_at']) ? utcDateToLocalDate(get(rowData, ['created_at'])) : '-'}
                              />
                              <Column
                                header={ t('accepted at') }
                                sortable
                                body={(rowData: any) => get(rowData, ['accepted_at']) ? utcDateToLocalDate(get(rowData, ['accepted_at'])) : '-'}
                              />
                              <Column
                                header={ t('rejected at') }
                                sortable
                                body={(rowData: any) => get(rowData, ['rejected_at']) ? utcDateToLocalDate(get(rowData, ['rejected_at'])) : '-'}
                              />
                          </DataTable>
                      </Col>
                  </Row>

                  <Divider />
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h5>
                              <span className="text-capitalize">{ t('history') }</span>
                          </h5>
                      </Col>
                      <Col sm="12">
                          <DataTable
                            value={ reverse((get(entity, ['histories']) || []).filter((h: any) => get(h, ['type']) !== 'comment')) }
                            dataKey="id"
                            paginator
                            rows={ 5 }
                            className="datatable-responsive"
                            emptyMessage={ t('no data') }
                          >
                              <Column
                                field="status"
                                header={ t('status') }
                                sortable
                                body={(rowData: any) => get(rowData, ['status']) || '-'}
                              />
                              <Column
                                field="user"
                                header={ t('user') }
                                sortable
                                body={(rowData: any) => ((toLower(get(rowData, ['user'])) === "admin a.") ? "Emil Frey" : get(rowData, ['user'])) || '-'}
                              />
                              <Column
                                field="created_at"
                                header={ t('created at') }
                                sortable
                                body={(rowData: any) => get(rowData, ['created_at']) ? utcDateToLocalDate(get(rowData, ['created_at'])) : '-'}
                              />
                          </DataTable>
                      </Col>
                  </Row>

                  <Divider />
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h5>
                              <span className="text-capitalize">{ t('comment(s)') }</span>
                          </h5>
                      </Col>
                      <Col sm="12">
                          <DataTable
                            value={ reverse((get(entity, ['histories']) || []).filter((h: any) => get(h, ['type']) === 'comment')) }
                            dataKey="id"
                            paginator
                            rows={ 5 }
                            className="datatable-responsive"
                            emptyMessage={ t('no data') }
                          >
                              <Column
                                field="user"
                                header={ t('user') }
                                sortable
                                body={(rowData: any) => get(rowData, ['user']) || '-'}
                              />
                              <Column
                                field="comment"
                                header={ t('comment') }
                                sortable
                                body={(rowData: any) => get(rowData, ['comment']) || '-'}
                              />
                              <Column
                                field="created_at"
                                header={ t('created at') }
                                sortable
                                body={(rowData: any) => get(rowData, ['created_at']) ? utcDateToLocalDate(get(rowData, ['created_at'])) : '-'}
                              />
                          </DataTable>
                      </Col>
                  </Row>

                  <Divider />
                  <Row>
                      <Col md="6" lg="6" sm="12">
                          <h5>
                              <span className="text-capitalize">{ t('documents') }</span>
                          </h5>
                      </Col>
                      <Col sm="12">
                          <DataTable
                            value={ (get(entity, ['documents']) || [])}
                            dataKey="id"
                            paginator
                            rows={ 5 }
                            className="datatable-responsive"
                            emptyMessage={ t('no data') }
                          >
                              <Column
                                field="title"
                                header={ t('title') }
                                sortable
                                body={(rowData: any) => get(rowData, ['title']) || '-'}
                              />
                              <Column
                                field="doc_type"
                                header={ t('type') }
                                sortable
                                body={(rowData: any) => get(rowData, ['doc_type']) || '-'}
                              />
                              <Column
                                field="created_at"
                                header={ t('created at') }
                                sortable
                                body={(rowData: any) => get(rowData, ['created_at']) ? utcDateToLocalDate(get(rowData, ['created_at'])) : '-'}
                              />
                              <Column
                                field="action"
                                header={ t('action') }
                                sortable
                                body={(rowData: any) => (
                                    <>
                                        <a href={ rowData.download_url } target="_blank">
                                            <i className="fas fa-download"></i>
                                        </a>
                                    </>
                                )}
                              />
                          </DataTable>
                      </Col>
                  </Row>

                  { selectedDamageCode && entity && get(props.dropdowns, ['providerUser']) && get(props.dropdowns, ['providerUser', 'id']) && (
                      <Chatbox
                          isOpen={ chatboxOpen }
                          onClose={ () => {
                              setChatboxOpen(false);
                              setSelectedDamageCode(null);
                          } }
                          participants={ get(entity, ['participants']) }
                          damageCase={ {
                              id: get(entity, ['id']),
                              emil_frey_id: get(selectedDamageCode, ['emil_frey_id']),
                              case_number: get(entity, ['case_number']),
                              damage_code: get(selectedDamageCode, ['code']),
                              damage_code_description: get(selectedDamageCode, ['description']),
                              status: get(entity, ['status']),
                          } }
                          masterUser={ get(props.dropdowns, ['providerUser']) }
                          allDamageCodes={ get(entity, ['damage_codes']) || [] }
                          onChangeDamageCode={ (newDamageCode: any) => {
                              // Update selected damage code to reload chat with new code
                              setSelectedDamageCode(newDamageCode);
                          } }
                      />
                  ) }
              </>
            }
        </div>
    );
};

ClosedOrderDamageCaseDetail.propTypes = {
    // t: PropTypes.any,
};

export default withTranslation()(WithRouter(ClosedOrderDamageCaseDetail));
